import {
  listSkillGroup, listRoles
} from '@/api/user'

const getDefaultRoleState = () => {
  return {
    roleId: '',
    curAddSysAuthData: [], // 新增角色选择的系统权限数据
    curAddWbAuthData: [], // 新增角色选择的坐席工作权限数据
    curAppAuthData: [], // app权限数据{aicc-crm:data,aicc-xxx:data}
    skillGroupData: [], // 技能组data缓存
    rolesData: [] // 角色data缓存
  }
}

const role = {
  namespaced: true, // true表示声明为【带命名空间】的模块,这样该模块下的state,mutations等属性中定义的变量属于【子命名空间】下的局部变量,不会与其他【子命名空间】下的变量冲突;不写namespaced:true,则本模块下的state属于【根命名空间】下的全局变量
  state: {
    roleId: '',
    curAddSysAuthData: [], // 新增角色选择的系统权限数据
    curAddWbAuthData: [], // 新增角色选择的坐席工作权限数据
    curAppAuthData: [], // app权限数据{aicc-crm:data,aicc-xxx:data}
    skillGroupData: [], // 技能组data缓存
    rolesData: [] // 角色data缓存
  },
  mutations: {
    setCurRoleId(state, roleId) {
      state.roleId = roleId
    },
    setCurAddSysAuthData(state, data) {
      state.curAddSysAuthData = data
    },
    setCurAddWbAuthData(state, data) {
      state.curAddWbAuthData = data
    },
    setSkillGroupData(state, data) {
      state.skillGroupData = data
    },
    setCurAppAuthData(state, data) {
      if (data instanceof Array) {
        state.curAppAuthData = data
      } else {
        /** 先删除之前的数组元素，再重新添加 */
        if (state.curAppAuthData.length && state.curAppAuthData.length > 0) {
          for (let i = 0; i < state.curAppAuthData.length; i++) {
            if (state.curAppAuthData[i].name === data.appId) {
              state.curAppAuthData.splice(i, 1)
              break
            }
          }
        }
        state.curAppAuthData.push({ name: data.appId, data: data.data })
      }
    },
    setRolesData(state, data) {
      state.rolesData = data
    },
    resetState (state) {
      Object.assign(state, getDefaultRoleState())
    }
  },
  actions: {
    _listSkillGroup({ commit }) {
      listSkillGroup()
        .then(res => {
          if (res.code === 2000) {
            commit('setSkillGroupData', res.data)
          }
        })
        .catch(() => {
        })
    },
    _listRoles({ commit }) {
      listRoles()
        .then(res => {
          if (res.code === 2000) {
            commit('setRolesData', res.data)
          }
        })
        .catch(() => {
        })
    }
  },
  modules: {
  }
}

export default role
